import { GET_CUSTOMERS } from "../actions/types";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CUSTOMERS:
      return {
        ...state,
        list: action.payload,
      };
    default:
      return state;
  }
}
